import React from 'react';
import { cn } from '@/entrypoints/utils';
import { useSetAtom } from 'jotai';
import { selectedDayAtom, selectedTimeSlotAtom } from './calendar-atoms';

type Props = {
  clinicTitle: string;
  clinicId: string;
  clinicHandle: string;
  defaultActive: boolean;
  setActiveClinic: (clinicHandle: string) => void;
};

function ClinicTab({ clinicTitle, clinicId, clinicHandle, defaultActive, setActiveClinic }: Props) {
  const setSelectedDay = useSetAtom(selectedDayAtom);
  const setSelectedTimeSlot = useSetAtom(selectedTimeSlotAtom);

  return (
    <button
      type="button"
      className={cn('medispa-calendar_tab', defaultActive && 'active')}
      data-product={clinicId}
      data-handle={clinicHandle}
      onClick={() => {
        setActiveClinic(clinicId);
        setSelectedDay(null);
        setSelectedTimeSlot(null);
      }}
    >
      {clinicTitle}
    </button>
  );
}

export default ClinicTab;
